import { Injectable } from '@angular/core';

type FileExtension = 'csv' | 'pdf' | 'xls' | 'xlsx' | 'doc' | 'docx' | 'zip';

@Injectable({providedIn: 'root'})
export class UtilsService {

    constructor() { }

    downloadFile(data: any, fileName?: string, _type?: FileExtension): void {
        console.log(fileName)
        const type =  (_type) ? _type : 'docx';
        const mime = this.getMimeType(type);
        const blob = new Blob([data], { type: mime });
        const url =  window.URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        const datetime = (new Date()).toJSON();

        anchor.download = `${fileName}-${datetime}.${type}`;
        anchor.href = url;
        anchor.click();
    }

    private getMimeType (typeName: FileExtension): string {
        let type: string;

        switch(typeName) {
            case 'csv': type  = 'text/csv'; break;
            case 'doc': type  = 'application/msword'; break;
            case 'docx': type = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'; break;
            case 'xls': type  = 'application/vnd.ms-excel'; break;
            case 'xlsx': type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'; break;
            case 'zip': type  = 'application/zip'; break;
            case 'pdf': type  = 'application/pdf'; break;
            default: type     = 'application/pdf'; break;
        }

        return type;
    }

}
